const supportedLocales = new Set(["ar", "de", "en", "es", "fr", "hi", "ja", "ru", "zh"]);

/** @returns {string|null} */
export function browserLanguageCode() {
    return browserLocaleTag()?.toLowerCase().split("-")[0] ?? null;
}

/** @returns {string|null} */
export function browserLocaleTag() {
    const preferredLanguages = [
        ...(globalThis.navigator?.languages || []),
        globalThis.navigator?.language,
    ].filter(Boolean);

    for (const locale of preferredLanguages) {
        const language = String(locale).toLowerCase().split("-")[0];
        if (supportedLocales.has(language)) return String(locale);
    }

    return null;
}
